import styled, { css } from "styled-components"
import { DialogContent } from "@material-ui/core"

export const Content = styled(DialogContent)`
  overflow-y: hidden;
`

export const Title = styled.h2`
  ${({ theme }) => css`
    margin: 0 0 16px 0;
    color: ${theme.colors.black};
    font-size: 26px;
    font-weight: 600;
    text-align: center;
  `}
`

export const Introduction = styled.p`
  ${({ theme }) => css`
    margin: 0 0 28px 0;
    color: ${theme.colors.grey};
    font-size: 14px;
    line-height: 18px;
  `}
`

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 20px;
`

export const Label = styled.label`
  ${({ theme }) => css`
    color: ${theme.colors.grey};
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
  `}
`

export const Input = styled.input`
  ${({ theme }) => css`
    width: 100%;
    height: 34px;
    padding: 0 14px;
    border: 1px solid ${theme.colors.borderDark};
    border-radius: 18px;
    font-size: 14px;

    &:focus {
      outline: none;
      border-color: ${theme.colors.primary};
    }
  `}
`

export const ScaleContainer = styled.div`
  position: relative;
  margin: 8px 0 18px 0;
  padding-left: 42px;

  &::before {
    content: "";
    position: absolute;
    left: 17px;
    top: 18px;
    bottom: 18px;
    width: 2px;
    background: linear-gradient(to bottom, #ef5350, #66bb6a);
  }

  &::after {
    content: "";
    position: absolute;
    left: 13px;
    bottom: 10px;
    width: 8px;
    height: 8px;
    border-right: 2px solid #66bb6a;
    border-bottom: 2px solid #66bb6a;
    transform: rotate(45deg);
  }
`

export const NegativeLabel = styled.div`
  color: #e57373;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 8px;
`

export const PositiveLabel = styled.div`
  color: #66bb6a;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  margin-top: 10px;
`

export const ChoiceRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`

export const DragIcon = styled.div`
  ${({ theme }) => css`
    font-size: 20px;
    line-height: 1;
    cursor: grab;

    &:active {
      cursor: grabbing;
    }

    &::before {
      content: "⠿";
    }
  `}
`

export const ChoiceInput = styled(Input)`
  max-width: 496px;
`

export const AddChoiceButtonWrapper = styled.div`
  margin: 8px 0 8px 25px;
  width: 300px;
`

export const DeleteChoiceButton = styled.button`
  ${({ theme }) => css`
    width: 28px;
    height: 28px;
    border: none;
    background: transparent;
    color: ${theme.colors.grey};
    cursor: pointer;
    font-size: 22px;
    line-height: 1;

    &:hover {
      color: ${theme.colors.danger};
    }
  `}
`

export const Warning = styled.p`
  ${({ theme }) => css`
    margin: 16px 0 26px 0;
    color: ${theme.colors.grey};
    font-size: 14px;
  `}
`

export const Actions = styled.div`
  display: flex;
  justify-content: center;
  gap: 76px;
  margin-top: 8px;
`
